import { Component, inject } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationService } from '../../../application/services/notification.service';

@Component({
    selector: 'banner',
    templateUrl: './banner.component.html',
    standalone: true,
    imports: [
        TranslateModule,
        MdIconComponent,
    ],
})

export class BannerComponent {
    private readonly notificationService = inject(NotificationService);

    public readonly status$$ = this.notificationService.status;

    public readonly props$$ = this.notificationService.props;

    public clickAction(): void {
        this.notificationService.clickAction();
    }

    public closeNotification(): void {
        this.notificationService.closeNotification();
    }
}
